import { render } from "./DashboardDataTable.vue?vue&type=template&id=5a3ea1e5"
import script from "./DashboardDataTable.vue?vue&type=script&lang=js"
export * from "./DashboardDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__